import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import NotFound from './pages/404'
import GestureRecognition from './pages/GestureRecognition'
import UserOs from './pages/UserOs'
import Mart from './pages/Mart'
import Itinerary from './pages/ItineraryMin'
import CustomerCredit from './pages/CustomerCredit'
import Home from './pages/Home'

const App = () => {
  return (
    <>  

        
      <Router>
        <Routes>
        <Route path='/'  element={<Home/>} />
          <Route path='/GestureRecognition'  element={<GestureRecognition/>} />
          <Route path='/UserOs'  element={<UserOs/>} />
          <Route path='/Mart'  element={<Mart/>} />
          <Route path='/ItineraryMin'  element={<Itinerary/>} />
          <Route path='/CreditAnalysis'  element={<CustomerCredit/>} />
          <Route path='*' element={<NotFound/>}/>
        </Routes>
      </Router>
    
    </>
  )
}

export default App